const url =
  process.env.GATSBY_DEVELOP === 'true'
    ? 'https://strapi.kode.ru'
    : 'https://strapi.kode.ru'

module.exports = {
  api_endpoint: `${url}/graphql`,
  static_endpoint: `${url}`,
}
